'use client';

import { useEffect } from 'react';
import { destroyVolcRtcEngine } from './engine';

/**
 * 引擎在 claim 成功后创建。这个 hook 只在离开 /editing-pro、/live-pro 时 destroy。
 */
export const useVolcRtcEngine = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    return () => {
      destroyVolcRtcEngine();
    };
  }, [enabled]);
};
